import httpService from "./httpService.js"

export const getAllServicesService = (page, limit, q, status) => {
    return httpService(`/shop_admin/service_admin_panel/?page=${page}&limit=${limit}&status=${status}${q ? `&q=${q}` : ""}`, "get");
};

export const getAllOrderedServiceForManagement = (page, limit, q, status) => {
    return httpService(`/shop_admin/management_contractor_list/?page=${page}&limit=${limit}&status=${status}${q ? `&q=${q}` : ""}`, "get");
};

export const addManagerDescription = (serviceCode, data) => {
    return httpService(`/shop_admin/add_manager_description/${serviceCode}/`, "patch", data);
};

export const getAllOrderedService = (page, limit, q) => {
    return httpService(`/shop_admin/ordered_service_list/?page=${page}&limit=${limit}${q ? `&q=${q}` : ""}`, "get");
};

export const getQcServices = (page, limit, q, status) => {
    return httpService(`/shop_admin/qc_service_list/?page=${page}&limit=${limit}&status=${status}${q ? `&q=${q}` : ""}`, "get");
};

export const updateQcStatus = (serviceCode, data) => {
    return httpService(`/shop_admin/qc_update_status/${serviceCode}/`, "patch", data);
};

export const getContractorServices = (page, limit, q, contractorId) => {
    return httpService(`/shop_admin/contractor_service_list/?page=${page}&limit=${limit}${q ? `&q=${q}` : ""}&contractorId=${contractorId}`, "get");
};

export const getContractorTransactions = (page, limit) => {
    return httpService(`/shop_admin/transaction_list/?page=${page}&limit=${limit}`, "get");
};

export const getSingleServiceDataService = (serviceCode) => {
    return httpService(`/shop_admin/service_admin_panel/${serviceCode}/`, "get");
}

export const editServiceService = (serviceCode, data) => {
    return httpService(`/shop_admin/service_admin_panel/${serviceCode}/`, "patch", data);
}

export const serviceAcceptanceRequest = (serviceCode, data) => {
    return httpService(`/shop_admin/service_acceptance_request/${serviceCode}/`, "patch", data);
}

export const qcRequest = (serviceCode, data) => {
    return httpService(`/shop_admin/qc_request/${serviceCode}/`, "patch", data);
}


export const visibilityRequest = (serviceCode, data) => {
    return httpService(`/shop_admin/visibility_request/${serviceCode}/`, "patch", data);
}

export const deletePhase = (id) => {
    return httpService(`/shop_admin/phase/${id}/`, "delete");
}
